<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label"><span class="mr-2">{{ function_name }} </span></div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="label mt-2">Condition</div>
              <div class="row">
                <div class="col-5">
                  <div class="sub-label">Opportunity:</div>
                  <b-form-input v-model="optyName"
                                placeholder=""
                                label="Opportunity:"
                                trim>
                  </b-form-input>
                </div>


                <div v-if="searchedData && searchedData.length && shippingPnSelection !== '' && shippingPnSelection.length" class="col-2">
                  <div class="sub-label">Shipping P/N:</div>
                  <gtc-multi-select v-model="customizationPartNumber"
                                    key-field="value" text-field="text"
                                    :options="shippingPnSelection"
                                    @change="onChangeShippingPn"
                                    select-class="w-100" class="w-100"></gtc-multi-select>
                </div>
                <div v-else class="col-3">
                  <div class="sub-label">Shipping P/N:</div>
                  <b-form-input v-model="customizationPartNumberSingle"
                                placeholder=""
                                label="Part Number:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">FTIE:</div>
                  <b-form-input v-model="ftieId"
                                placeholder=""
                                label="FTIE:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">Unique Component P/N:</div>
                  <b-form-input v-model="partNumber"
                                placeholder=""
                                label="Part Number:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">Model:</div>
                  <gtc-multi-select v-model="selected_model" key-field="value" text-field="text" :multiple="false"
                                    :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
                </div>
              </div>
            </div>
          </div>
          <!--<div class="row">
            <div class="col">
              <div class="label mt-2"></div>
              <div class="row">

                <div class="col-3">
                  <div class="sub-label">FTIE:</div>
                  <b-form-input v-model="ftieId"
                                placeholder=""
                                label="FTIE:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-2"> </div>
                <div class="col-4">
                  <div class="sub-label">Unique Component P/N:</div>
                  <b-form-input v-model="partNumber"
                                placeholder=""
                                label="Part Number:"
                                trim>
                  </b-form-input>
                </div>
                <div class="col-3">
                  <div class="sub-label">Model:</div>
                  <gtc-multi-select v-model="model" key-field="value" text-field="text" :multiple="false"
                                    :options="model_options" select-class="w-100" class="w-100"></gtc-multi-select>
                </div>
              </div>
            </div>
          </div>-->

        </div>
        <div class="col-auto align-self-end" style="width: 11.5rem">
          <b-button @click="searchInventory()" variant="primary">Search</b-button>
          <!--
                <b-button @click="resetFilterCondition()" variant="btn btn-outline-primary">Reset</b-button>
  -->

        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex">
        <div v-if="rows && rows!==0 && searchedData && searchedData.length && searching === false" class="h5 font-weight-bold">
          {{ rows }} Results

        </div>
        <div v-else class="h5 font-weight-bold">
          {{ rows }} Results
        </div>
        <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                v-b-tooltip.hover title="Download Inventory Report"
                @click="reportDownload()"></button>
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <!-- region: shipping info master table-->
      <div class="table-responsive" style="min-height: 2.5rem" v-if="searchedShipInfoData !== null && searchedShipInfoData !== []">
        <b-table :fields="shipInfofields" :items="searchedShipInfoData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2" rowspan="3">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(ftie_id)="data">
            <!--<gtc-link-to-ftie-dashboard :ftieId="data.item.ftie_id" />-->
            <a class="link" target="_blank" :href="safeUrl(`${ $root.frontEndUrl }/inventory/ftie/${ data.item.ftie_id }`)">{{ data.item.ftie_id }}</a>
          </template>

          <template #cell(sfdc_opty_name)="data">
            <gtc-opty-inventory :opportunityId="data.item.sfdc_opty_id"
                                :opportunityName="data.item.sfdc_opty_name" />
          </template>
        </b-table>
      </div>
      <!-----  -->
      <!-- end region-->
      <!--<div class="table-responsive" style="min-height: 2.5rem">
        <b-table :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2" rowspan="3">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(ftie_id)="data">
            <gtc-ftie :ftieId="data.item.ftie_id" />
          </template>

          <template #cell(sfdc_opty_name)="data">
            <gtc-opty-inventory :opportunityId="data.item.sfdc_opty_id"
                                :opportunityName="data.item.sfdc_opty_name" />
          </template>

          <template #cell(inventory)="data">
            <div v-if="data.item.inventory_qty_total && data.item.inventory_info_list">
              <button v-b-modal.modal-1 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      @click="showDetailData(data.item, data.item.pn)"
                      v-b-tooltip.hover.left title="Sub-inventory Detail"></button>
              <span class="font-weight-bold">{{data.item.inventory_qty_total}}</span>-->

              <!--<b-button v-b-modal.modal-1 @click="showDetailData(data.item.inventory_info_list, data.item.pn)">Detail</b-button> -->

            <!--</div>
            <div v-else style="padding-left: 31px;">-->
              <!--
            <button v-b-modal.modal-zero-enventory class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
            @click="zeroInventoryData(data.item, data.item.pn)"
            v-b-tooltip.hover title="No inventory found"></button>

            <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" v-b-tooltip.hover title="No inventory found"></button>
          -->

              <!--<span class="font-weight-bold">0</span>
            </div>
          </template>
          <template #cell(po_info)="data">
            <div v-if="data.item.po_info && data.item.po_info.po_total_qty" style="padding-left: 31px;">-->
              <!--
          <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
              v-b-tooltip.hover.left :title=" `${data.item.po_info.po_detail} `"></button>
              -->
              <!--<span>{{data.item.po_info.po_total_qty}}</span>
            </div>
            <div v-else style="padding-left: 31px;">
              <span>0</span>
            </div>
          </template>
          <template #cell(pr_info)="data">
            <div v-if="data.item.pr_info && data.item.pr_info.pr_total_qty" style="padding-left: 31px;">-->
              <!--
          <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
              v-b-tooltip.hover.left :title=" `${data.item.pr_info.pr_detail} `"></button>
          -->

              <!--<span>{{data.item.pr_info.pr_total_qty}}</span>
            </div>
            <div v-else style="padding-left: 31px;">
              <span>0</span>
            </div>
          </template>

        </b-table>
        <b-modal centered
                 id="modal-1"
                 :title=" `Inventory Detail - ${inventoryObjToShow.pn} `"
                 ok-only>
          <div class="header-col">
            <div>Project Name</div>
            <div>{{ inventoryObjToShow.projectName }}</div>
          </div>
          <div class="header-col">
            <div>Project Code</div>
            <div>{{ inventoryObjToShow.projectCode }}</div>
          </div>
          <div class="header-col mb-4">
            <div>Product Code</div>
            <div>{{ inventoryObjToShow.productCode }}</div>
          </div>
          <div class="border-bottom" style="margin-bottom: 23px;"></div>
          <div v-if="inventoryObjToShow.poItems && inventoryObjToShow.poItems.po_total_qty" class="header-col">
            <div>PO Qty</div>
            <div>
              <button v-if="inventoryObjToShow.poItems.po_detail" v-b-modal.modal-1 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.right :title=" `${inventoryObjToShow.poItems.po_detail} `"></button>
              {{ inventoryObjToShow.poItems.po_total_qty }}
            </div>
          </div>
          <div v-else class="header-col">
            <div>PO Qty</div>
            <div></div>
          </div>

          <div v-if="inventoryObjToShow.prItems && inventoryObjToShow.prItems.pr_total_qty" class="header-col mb-4">
            <div>PR Qty</div>
            <div>
              <button v-if="inventoryObjToShow.prItems.pr_detail" v-b-modal.modal-1 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                      v-b-tooltip.hover.right :title=" `${inventoryObjToShow.prItems.pr_detail} `"></button>
              {{ inventoryObjToShow.prItems.pr_total_qty }}
            </div>
          </div>
          <div v-else class="header-col mb-4">
            <div>PR Qty</div>
            <div></div>
          </div>

          <div class="border-bottom" style="margin-bottom: 23px;"></div>
          <b-table :fields="inventoryFields"
                   :items="inventoryObjToShow.inventoryItems"
                   small
                   thead-class="thead-light text-dark"
                   :busy="searching"
                   ref="DetailModal"
                   style="width: calc(100% - 10px)">
          </b-table>
        </b-modal>
        <b-modal centered
                 id="modal-zero-enventory"
                 :title=" `Inventory Detail - ${inventoryObjToShow.pn} `"
                 ok-only>
          <div class="header-col">
            <div>No inventory data fround for PN {{inventoryObjToShow.pn}}! </div>
          </div>
        </b-modal>

      </div>-->
      <!--<div class="d-flex pr-3">
        <div class="ml-auto">
          <b-pagination v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :disabled="pageDisabled"
                        :limit="pageLimit"
                        @change="pageChange">
          </b-pagination>
        </div>
      </div>
      <div class="row mx-n1 align-items-center pr-3">
        <div class="px-1 col-auto ml-auto">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
        </div>
        <div class="px-1 col-auto">
          <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div class="px-1 col-auto">rows per page</div>
      </div>-->
    </div>

  <!--#endregion -- Body ---->

</div>

</template>

<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'dashboard',
    data() {
      return {
        function_name: 'Inventory Report',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        authUrl: '',
        frontendUrl: '',
        thisPageLoadingCnt: 0,
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        fileName: '',
        downLoadSuccess: '',
        //GRO: '',
        //GROText: '',

        //model_options: [],
        //model: '', //PM Stryker - TACOM - T800s Spiral 1 - 2020
        ftieId: '',
        partNumber: '',
        optyName: '', //PM Stryker - TACOM - T800s Spiral 1 - 2020
        customizationPartNumber: '',
        customizationPartNumberSingle: '',
        shippingPnSelection: '',
        //my_status_options: [{ value: 'InProgress', text: 'In Progress' }, { value: 'Oncoming', text: 'Oncoming' }],
        //my_status: '',

        //NRE_status_options: [],
        //NRE_status: [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }],

        //ticket_status_options: [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        //ticket_status: [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],

        //reason_text: null,

        searchedShipInfoData: [],
        searchedShipInfoDataAll: [],
        shipInfoTotalCount: '',
        mergedShipInfoDfResult: null,

        already_first_search_flag: false,
        shipInfofields: [
          {
            key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true,
            tdStyle: { 'rowspan': "3" },
          },
          // key: 'account', label: 'Account Name', thClass: 'align-middle', sortable: true },
          { key: 'sfdc_opty_name', label: 'Salesforce Opportunity', thClass: 'align-middle', sortable: true },
          { key: 'ref_sku', label: 'STD Ref SKU', thClass: 'align-middle', sortable: true},
          { key: 'customization_shipping_pn', label: 'Shipping P/N', thClass: 'align-middle', sortable: true },
          { key: 'customization_shipping_pn_description', label: 'Shipping P/N Description', thClass: 'align-middle', sortable: false },
          //{ key: 'project_info.MODEL_NAME', label: 'Model', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PROJECT_NAME', label: 'Project Name', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PROJECT_CODE', label: 'Project Code', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PRODUCT_CODE', label: 'Product Code', thClass: 'align-middle', sortable: true },
        ],
        fields: [
          {
            key: 'ftie_id', label: 'FTIE ID', thClass: 'align-middle', sortable: true,
            tdStyle: { 'rowspan': "3" },
          },
          // key: 'account', label: 'Account Name', thClass: 'align-middle', sortable: true },
          { key: 'sfdc_opty_name', label: 'Salesforce Opportunity', thClass: 'align-middle', sortable: true },
          { key: 'customization_shipping_pn', label: 'Shipping P/N', thClass: 'align-middle', sortable: true },
          { key: 'pn', label: 'Unique Compo P/N', thClass: 'align-middle', sortable: true },
          { key: 'pn_description', label: 'Unique Compo P/N Description', thClass: 'align-middle', sortable: false },
          //{ key: 'project_info.MODEL_NAME', label: 'Model', thClass: 'align-middle', sortable: false },
          { key: 'project_info.PROJECT_NAME', label: 'Project Name', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PROJECT_CODE', label: 'Project Code', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PRODUCT_CODE', label: 'Product Code', thClass: 'align-middle', sortable: true },

          //{key: 'inventory_qty_total', label: 'Total', thClass: 'align-middle', sortable: true},
          {
            key: 'inventory', label: 'Inventory Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true, sortByFormatted: true,
            formatter: (value, key, item) => {
              return item.inventory_qty_total
            }
          },
          {
            key: 'po_info', label: 'PO Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true, sortByFormatted: true,
          },
          {
            key: 'pr_info', label: 'PR Qty', thClass: 'align-middle', tdClass: '',
            tdStyle: { 'min-width': '47rem', 'rowspan': "3" },
            sortable: true, sortByFormatted: true,
          }
        ],
        inventoryFields: [
          { key: 'SUBINVENTORY_CODE', label: 'Sub-inventory Code', thClass: 'align-middle', sortable: true },
          { key: 'SUBINVENTORY_NAME', label: 'Sub-inventory Name', thClass: 'align-middle', sortable: true },
          { key: 'INVENTORY_QTY', label: 'Qty', thClass: 'align-middle', sortable: true },
          /*
          { key: 'project_info.MODEL_NAME', label: 'Model', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PROJECT_NAME', label: 'Project Name', thClass: 'align-middle', sortable: true },
          { key: 'project_info.PROJECT_CODE', label: 'Project Code', thClass: 'align-middle', sortable: false },
          { key: 'project_info.PRODUCT_CODE', label: 'Product Code', thClass: 'align-middle', sortable: false }
          */
        ],
        poFields: [
          { key: 'po_total_qty', label: 'PO Qty', thClass: 'align-middle', sortable: true },
          { key: 'po_detail', label: 'PO Detail', thClass: 'align-middle', sortable: true },
        ],

        prFields: [
          { key: 'pr_total_qty', label: 'PR Qty', thClass: 'align-middle', sortable: true },
          { key: 'pr_detail', label: 'PR Detail', thClass: 'align-middle', sortable: true },
        ],

        inventoryObjToShow: {
          inventoryItems: [],
          poItems: '',
          prItems: '',
          pn: '',
          pnDescription: '',
          projectName: '',
          projectCode: '',
          productCode: '',
        },

        searchedData: [],
        searchedDataAll: [],
        mergedDataframe: '',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        nreTotalCount: '',
        model_options: [],
        selected_model:''
      }
    },
    created() {
      let self = this;
      let access_flag = self.inventoryReportAccess();
      if (access_flag== false) {
        self.$router.push('/home');
      }
    },
    computed: {
      rows() {
        return this.nreTotalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.thisPageLoadingCnt = 0;
      if (this.$route.params.keywords){
        this.keywords = this.$route.params.keywords;
        this.date_from = '';
        this.date_to = '';
        //this.searchInventory();
      }
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },

      onChangeShippingPn(customizationPartNumber) {
        if (customizationPartNumber.length > 0) {
          this.customizationPartNumberSingle = '';
        }
      },

      showDetailData(dataItem, pn) {
        let self = this;
        let inventoryInfoList = dataItem.inventory_info_list
        self.inventoryObjToShow = {
          inventoryItems: JSON.parse(JSON.stringify(inventoryInfoList)),
          pn: pn,
          projectName: dataItem.project_info.PROJECT_NAME,
          projectCode: dataItem.project_info.PROJECT_CODE,
          productCode: dataItem.project_info.PRODUCT_CODE,
          poItems: dataItem.po_info,
          prItems: dataItem.pr_info,
        };
        console.log("inventoryObjToShow::");
        console.log(self.inventoryObjToShow);
        //self.$refs['DetailModal'].show();
      },

      zeroInventoryData(dataItem, pn) {
        let self = this;
        self.inventoryObjToShow = {
          pn: pn,
        };
        console.log("zeroInventoryData::");
        console.log(self.zeroInventoryData);
        //self.$refs['DetailModal'].show();
      },

      tooltipTitle(data, stage_index) {
        let self = this;
        var signing_stage = data.item.signing_stages[stage_index];
        return _.trim(self.stageTip[stage_index] + ' ' + _.trim(_.get(signing_stage, 'status_name', '')))
      },

      tooltipReason(data) {
        let self = this;
        return _.trim(_.get(data.item, 'reject_reason', ''))
      },

      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;

        //this.ownerSelectionDic = options.owner_dic_with_region_key;

        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);
        this.model_options.unshift({ value: '', text: 'ALL' });
        //var gro_option_new = new Array();
        //for (i = 0; i < options.gro_opt_val_list.length; i++) {
        //  gro_option_new.push({ value: options.gro_opt_val_list[i], text: options.gro_opt_text_list[i] })
        //}
        //this.GRO = gro_option_new[0].value;
        //this.GROText = gro_option_new[0].text;


      },

      // TODO: NEW
      searchInventory() {
        if (this.thisPageLoadingCnt == 0) {
          this.already_first_search_flag = false;
          this.thisPageLoadingCnt = this.thisPageLoadingCnt + 1;
        }
        this.currentPage = 1;

        if (this.prdEnv()) {
          this.getShipInfo();
        } else {
          console.log("DEV/UAT Mode, get ship info table for developming purpose");
          this.getShipInfo(); // new inventory report: get ship info table first before inventory
        }
      },
      pageChange(page) {
        this.currentPage = page;
        if (this.searchedDataAll && this.searchedDataAll.length > 0 && this.searchedDataAll !== '' && this.nreTotalCount !== null && this.nreTotalCount > 0) {
          this.buildDataIndexbyPage();
        }
        else {
          this.getInventory(); // api call
        }
      },
      perPageChange() {
        this.currentPage = 1;
        if (this.searchedDataAll && this.searchedDataAll.length > 0 && this.searchedDataAll !== '' && this.nreTotalCount !== null && this.nreTotalCount > 0) {
          this.buildDataIndexbyPage();
        }
        else {
          this.getInventory(); // api call
        }
      },

      // TODO: NEW- DOWNLOAD
      reportDownload() {
        let self = this;
        let url = self.$root.baseUrl + '/inventory-management/unique_component/download/';
        console.log('####inventory management - download######');
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          if (self.customizationPartNumberSingle !== '') {
            customizationShippingPnSelected.push(self.customizationPartNumberSingle);
          }
          else {
            customizationShippingPnSelected = '';
          }
        } else {
          for (i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }


        let optyList = [];
        if (self.optyName !== '') {
          optyList.push(self.optyName);
        }

        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();
        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15301', '15974', '14662'],
          opty_name: optyList,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected,
          downloadTime: downloadTime,
          mergedDataframe: self.mergedDataframe
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = 'iventory_report_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });

        /*
                self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              self.fileName = res['file_name'];
              self.downLoadSuccess = res['download_success'];
              console.log("export success!!");
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            //self.already_first_search_flag = true;
            //if (self.already_first_search_flag == true) {
              //eventHub.$emit('loading', false);
            //}
          })

        */
      },

      // NEW INVENTORY REPORT - FIRST STEP AFTER CLICK SEARCH
      getShipInfo() {
        let self = this;
        if (self.thisPageLoadingCnt == 0) {
          self.already_first_search_flag = false;
          self.thisPageLoadingCnt = self.thisPageLoadingCnt + 1;
        }
        let url = self.$root.baseUrl + '/inventory-management/customization-ship-info/';
        console.log('####getShipInfo######');
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          if (self.customizationPartNumberSingle !== '') {
            customizationShippingPnSelected.push(self.customizationPartNumberSingle);
          }
          else {
            customizationShippingPnSelected = '';
          }
        } else {
          for (i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }


        let optyList = [];
        if (self.optyName !== '') {
          optyList.push(self.optyName);
        }

        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15301', '15974', '14662'],
          opty_name: optyList,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected,
          project_name: _.get(self.selected_model, 'value', null)
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedShipInfoData = [];
        let searchedShipInfoDataAll = [];
        let shipInfoTotalCount = 0;
        let mergedShipInfoDfResult = '';
        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              console.log("response:");
              console.log(res)
              searchedShipInfoData = JSON.parse(res['ship_info_obj_list']);
              searchedShipInfoDataAll = JSON.parse(res['ship_info_obj_list']);
              //mergedShipInfoDfResult = res['merged_dataframe'];
              shipInfoTotalCount = parseInt(res['total_count']);

              // END REGION
              //console.log(self.shippingPnSelection);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedShipInfoData = searchedShipInfoData;
            self.searchedShipInfoDataAll = searchedShipInfoDataAll;
            self.shipInfoTotalCount = shipInfoTotalCount;
            self.mergedShipInfoDfResult = mergedShipInfoDfResult;
            // REGION:: TODO: REBUILD LIST BY PAGE
            //self.buildDataIndexbyPage();
            // END REGION:: TODO: REBUILD LIST BY PAGE

          })
      },
      // TODO: NEW
      getInventory() {
        let self = this;
        if (self.thisPageLoadingCnt == 0) {
          self.already_first_search_flag = false;
          self.thisPageLoadingCnt = self.thisPageLoadingCnt + 1;
        }
        let url = self.$root.baseUrl + '/inventory-management/unique_component/';
        console.log('####inventory management######');
        let ftieList = [];
        if (self.ftieId !== '') {
          ftieList.push(self.ftieId);
        }

        let partNumberList = [];
        if (self.partNumber !== '') {
          partNumberList.push(self.partNumber);
        }

        let customizationShippingPnSelected = [];
        if (self.customizationPartNumber.length == 0) {
          if (self.customizationPartNumberSingle !== '') {
            customizationShippingPnSelected.push(self.customizationPartNumberSingle);
          }
          else {
            customizationShippingPnSelected = '';
          }
        } else {
          for (i = 0; i < self.customizationPartNumber.length; i++) {
            customizationShippingPnSelected.push(self.customizationPartNumber[i]['value'])
          }
        }


        let optyList = [];
        if (self.optyName !== '') {
          optyList.push(self.optyName);
        }

        let request_data = {
          part_number: partNumberList,
          ftie_id: ftieList,//['15301', '15974', '14662'],
          opty_name: optyList,
          record_per_page: self.perPage,
          page_index: self.currentPage,
          keywords: self.keywords,
          customization_shipping_pn: customizationShippingPnSelected
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        let searchedDataAll = [];
        let nreTotalCount = 0;
        let mergedDfResult = '';
        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['unique_parts_info_list']);
              searchedDataAll = JSON.parse(res['unique_parts_info_list']);
              mergedDfResult = res['merged_dataframe'];
              nreTotalCount = parseInt(res['total_count']);
              let customizationPnResult = res['shipping_pn_list'];
              let customizationPnSelection = [];
              //console.log(searchedData);
              var i;
              for (i = 0; i < customizationPnResult.length; i++) {
                customizationPnSelection.push({ value: customizationPnResult[i], text: customizationPnResult[i] });
              }

             // REGION: set chosen customizationPartNumber
             // -- set chosen customizationPartNumber by previous searching (select all at first)
              console.log("res['chosen_shipping_pn']::");
              console.log(res['chosen_shipping_pn']);
              if (res['chosen_shipping_pn'] !== null && res['chosen_shipping_pn'].length > 0) {
                var i;
                let customizationPartNumberChosenBefore = [];
                for (i = 0; i < res['chosen_shipping_pn'].length; i++) {
                  customizationPartNumberChosenBefore.push(res['chosen_shipping_pn'][i]);
                }
                //self.customizationPartNumber = customizationPartNumberChosenBefore;
                //self.customizationPartNumber = JSON.parse(JSON.stringify(res['chosen_shipping_pn']));
              }
             //-- set chosen customizationPartNumber by all
              else {
                if (customizationPnSelection !== []) {
                  self.shippingPnSelection = JSON.parse(JSON.stringify(customizationPnSelection));
                  //self.customizationPartNumber = customizationPnSelection[0]['value'];
                } else {
                  self.shippingPnSelection = '';
                  self.customizationPartNumber = '';
                }

              }
              console.log("self.customizationPartNumber::");
              console.log(self.customizationPartNumber);
              // END REGION
              //console.log(self.shippingPnSelection);


            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
              self.shippingPnSelection = '';
              self.customizationPartNumber = '';
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              self.shippingPnSelection = '';
              self.customizationPartNumber = '';
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
            self.shippingPnSelection = '';
            self.customizationPartNumber = '';
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.searchedDataAll = searchedDataAll;
            self.nreTotalCount = nreTotalCount;
            self.mergedDataframe = mergedDfResult;
            // REGION:: TODO: REBUILD LIST BY PAGE
            self.buildDataIndexbyPage();
            // END REGION:: TODO: REBUILD LIST BY PAGE
          })
      },

      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        //self.my_status = [];
        //self.model = '';
        self.ftieId = '';
        self.optyName = '';
        self.partNumber = '';
        self.shippingPnSelection = '';
        self.customizationPartNumber = '';
        self.customizationPartNumberSingle = '';
        //self.GRO = '';
        self.date_from = '';
        self.date_to = '';
        //self.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];//{Ongoing, Waiting}
        //self.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        //self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
      },
      buildDataIndexbyPage() {
        let self = this;
        //self.perPage
        //self.currentPage
        //self.
        if (self.searchedDataAll && self.searchedDataAll.length > 0 && self.nreTotalCount !== null && self.nreTotalCount > 0) {
          let startIndex = (self.currentPage - 1) * self.perPage;
          if (startIndex < self.nreTotalCount - 1) {
            let endIndex = (startIndex + self.perPage);
            if (endIndex > self.nreTotalCount) {
              endIndex = self.nreTotalCount;
            }
            self.searchedData = _.slice(self.searchedDataAll, startIndex, endIndex);
          }
        }
      },
      inventoryReportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1) || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1) || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
          || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1) || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
        ) {
          console.log("Access to inventory report!");
          return true
        }
        return false;
      },
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/InventoryDashboard.vue